import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const UserManagementPanel = () => {
  const [pendingApprovals] = useState([
    { id: 1, name: 'Carlos Mendoza', email: 'carlos.m@email.com', date: '2026-01-10' },
    { id: 2, name: 'Ana Rodríguez', email: 'ana.r@email.com', date: '2026-01-11' }
  ]);

  const handleApprove = (userId) => {
    // TODO: Approve user in Supabase
    console.log('Approving user:', userId);
  };

  const handleReject = (userId) => {
    // TODO: Reject user in Supabase
    console.log('Rejecting user:', userId);
  };

  return (
    <div className="card p-6">
      <div className="flex items-center justify-between mb-6">
        <h2 className="text-xl font-semibold text-foreground flex items-center">
          <Icon name="UserCheck" size={24} className="mr-2 text-primary" />
          Gestión de Usuarios
        </h2>
        <span className="px-3 py-1 bg-primary/10 text-primary text-sm font-medium rounded-full">
          {pendingApprovals?.length} pendientes
        </span>
      </div>

      <div className="space-y-4">
        {pendingApprovals?.length > 0 ? (
          pendingApprovals?.map((user) => (
            <div key={user?.id} className="p-4 border border-border rounded-lg hover:bg-muted/50 transition-colors">
              <div className="flex items-start justify-between mb-3">
                <div>
                  <h3 className="font-medium text-foreground">{user?.name}</h3>
                  <p className="text-sm text-muted-foreground">{user?.email}</p>
                  <p className="text-xs text-muted-foreground mt-1">Solicitado: {user?.date}</p>
                </div>
              </div>
              <div className="flex items-center space-x-2">
                <Button
                  size="sm"
                  iconName="Check"
                  onClick={() => handleApprove(user?.id)}
                >
                  Aprobar
                </Button>
                <Button
                  size="sm"
                  variant="outline"
                  iconName="X"
                  onClick={() => handleReject(user?.id)}
                >
                  Rechazar
                </Button>
              </div>
            </div>
          ))
        ) : (
          <div className="text-center py-8">
            <Icon name="CheckCircle" size={48} className="mx-auto mb-3 text-muted-foreground" />
            <p className="text-muted-foreground">No hay solicitudes pendientes</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default UserManagementPanel;